import { emitAnalyticsEvent, emitConfirmedLead, type AnalyticsParams } from "@/lib/analytics-events";
import type { Lang } from "@/lib/types";

export type CampaignContext = { campaign: string; adGroup: string };
export type CampaignEventName = "campaign_cta_click" | "campaign_calculator_use" | "campaign_form_start";

/** Compatibility events use the same consent gate and delivery as the rest of the site. */
export function trackCampaignEvent(event: CampaignEventName, context: CampaignContext, params: AnalyticsParams = {}): void {
  emitAnalyticsEvent(event, { campaign: context.campaign, ad_group: context.adGroup, ...params });
}

/** Called only after the backend confirms the short campaign form was saved. */
export function trackCampaignFormLead(lang: Lang, context: CampaignContext): void {
  emitConfirmedLead({ campaign: context.campaign, ad_group: context.adGroup, language: lang,
    form_id: "campaign_form", method: "contact_form" }, "campaign_form_submit", "campaignForm");
}
